<template>
  <div>
    <div class="title-bar detail clearfix">
      <div class="module pull-left">
        {{ $t("editCashback") }}
    </div>
      <div style="float:right;">
        <el-button   plain size="mini" @click="addEAN('addCashbackForm')">{{ $t("save") }}         
        </el-button>
        <el-button   plain size="mini" @click="cancelOperation">{{ $t("cancel") }}       
        </el-button>
      </div>
    </div>

 <div class="data-list detail">
    <div class="detail-header">
      <span>返现信息</span>
      <div class="detail-triangle"></div>
    </div>
    
    <div class="detail-content">
      <el-form class="detail-form" size="small"  ref="addCashbackForm" :model="CashbackInfo" label-width="120px" :rules="rules" status-icon>
        <el-row>
      <el-col :xs="24" :sm="12" :md="12" :lg="12" >      
        <el-form-item :label="this.$t('EANCode')" prop="EANCode"  >
          <el-input v-model="CashbackInfo.EANCode" disabled="disabled"></el-input>
        </el-form-item>

         

        <el-form-item :label="this.$t('CashbackAmount')" prop="CashbackAmount" >
           <div @keyup="handlekeyup($event)">
        <el-input  v-model.number="CashbackInfo.CashbackAmount" @focus="handlefocus" :autofocus="true" ></el-input>
          </div>
        </el-form-item>   
        
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="12" >
        <el-form-item :label="this.$t('ProductLongCode')" prop="ProductLongCode" >
          <el-input  v-model="CashbackInfo.ProductLongCode" disabled="disabled"></el-input>
        </el-form-item>

       
        <el-form-item :label="this.$t('UserType')" size="small" >
                <el-select v-model="CashbackInfo.UserType"  size="small"  disabled="disabled" style="width: 100%" >
                  <el-option  :key="CashbackInfo.UserType" :label="$t('UserType'+CashbackInfo.UserType)" :value="CashbackInfo.UserType"></el-option>
                </el-select>
            </el-form-item>       
      </el-col>   
        </el-row>  
    </el-form>
     </div>
  </div>
  
</div>
</template>


<script>
 import _ from "lodash";
 import CashbackAmountValidation from "./CashbackAmountValidation";
export default {
  name: "EditCashback",
  data() {
    return {
      maxCashbackAmount:CashbackAmountValidation.maxCasbackAmount,
      minCashbackAmount:CashbackAmountValidation.minCasbackAmount,
      CashbackInfo: {
        Id:'',
        EANCode:'',
        CashbackAmount:'',
        ProductLongCode: '',
        CashbackInformation:'',
        UserType:''
      },
       rules: {
         CashbackInformation: [{ required: true, message: this.$t("CashbackInformationValidation") }],
         CashbackAmount: [
             { required: true, message: this.$t("CashbackAmountValidation") },
               { type: 'number', message: this.$t("IsNumValidation")},
              {
                 validator: (rule, value, callback) => {
               
                if (parseFloat(value)>this.maxCashbackAmount) {
           
                callback(new Error("最大返现金额不能超过"+this.maxCashbackAmount+"元"));
              } else {
                  if (0<parseFloat(value)&&parseFloat(value)<1) {     
                callback(new Error("金额不能低于"+this.minCashbackAmount+"元"));
              }  
              else{
                 callback();
              }
                
              }
              }, trigger: 'blur'
              }
               
              
         ]
      }
      
     }
  
   },
     created() {
         
        this.$axios.get(`api/cashback/${this.$route.params.Id}`).then(response => {
        this.CashbackInfo.Id=response.data.Id;
        this.CashbackInfo.EANCode = response.data.EANCode;
        this.CashbackInfo.ProductLongCode = response.data.ProductLongCode;
        this.CashbackInfo.CashbackInformation = response.data.CashbackInformation;
        this.CashbackInfo.CashbackAmount=response.data.CashbackAmount;
        this.CashbackInfo.UserType=response.data.userType;
       // var elements=document.getElementsByClassName("el-input__inner");
        //elements[2].focus();
        
    });
     },
    methods:{
         
        addEAN(addCashbackForm) {
        this.$refs[addCashbackForm].validate(valid => {
        if (valid) {
          this.$axios.post("api/cashback/edit", this.CashbackInfo).then(response => {
            if(this.CashbackInfo)
            this.$message({
              message: this.$t("CashbackEditSuccessfully"),          
              type: "success",
              showClose: true,
              duration: 2000
            });
            this.$router.push({ name: "Cashback" });
          });
        } else {
          this.$message({
            message: this.$t("operationFailure"),
            type: "error",
            showClose: true,
            duration: 2000
          });
        }
      });
      },
       handlekeyup(event)
          {   
            var father=event.currentTarget;
            var obj=father.getElementsByTagName("input")[0];
            obj.value = obj.value.replace(/[^\d.]/g,"");  //清除“数字”和“.”以外的字符  
            obj.value = obj.value.replace(/\.{2,}/g,"."); //只保留第一个. 清除多余的  
            obj.value = obj.value.replace(".","$#$").replace(/\./g,"").replace("$#$","."); 
             obj.value = obj.value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');//只能输入两个小数  
              if(obj.value.indexOf(".")< 0 && obj.value !=""){ 
              obj.value= parseFloat(obj.value); 
           } 
              
          },
      handlefocus(ev)
      {      
        // this.CashbackInfo.AmountPerPackage=parseInt( this.CashbackInfo.AmountPerPackage);
      },
      cancelOperation() {
      this.$router.push({ name: "Cashback" });
     }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/application/Cashback/EditCashback.vue